document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.fit-tailor-block');

  blocks.forEach(blockEl => {
    const midHeight = parseFloat(blockEl.dataset.initHeight);
    const minHeight = parseFloat(blockEl.dataset.minHeight);
    const maxHeight = parseFloat(blockEl.dataset.maxHeight);
    const carLengthCm = Math.min(parseFloat(blockEl.dataset.carLength) || 200, 200);

    const thumb = blockEl.querySelector('.slider-thumb');
    const valueEl = thumb.querySelector('.slider-value');
    const okBox = blockEl.querySelector('[data-is-match]');
    const failBox = blockEl.querySelector('[data-not-match]');
    const personImg = blockEl.querySelector('.person');
    const bikeImg = blockEl.querySelector('.bike');
    const track = blockEl.querySelector('.slider-track');

    let line = blockEl.querySelector('.slider-line');
    if (!line) {
      line = document.createElement('div');
      line.className = 'slider-line';
      track.parentElement.appendChild(line);
    }

    const range = (midHeight < 180) ? 24 : 27;
    const min = midHeight - range - 1;
    const max = midHeight + range;
    const slideScale = 0.85;

    let dragging = false;
    let currentHeight = midHeight;

    function updateMatch(heightCm) {
      if (okBox && failBox) {
        if (heightCm >= minHeight && heightCm <= maxHeight) {
          okBox.style.display = 'block';
          failBox.style.display = 'none';
        } else {
          okBox.style.display = 'none';
          failBox.style.display = 'block';
        }
      }
    }

    function updatePersonHeight(heightCm) {
      if (!personImg || !bikeImg) return;
      const bikeWidth = bikeImg.getBoundingClientRect().width;
      if (bikeWidth === 0) return;

      const delta = heightCm - midHeight;
      const adjustedHeight = midHeight + delta * slideScale;
      const pxPerCm = bikeWidth / carLengthCm;
      const personHeightPx = adjustedHeight * pxPerCm;


    personImg.style.height = personHeightPx + 'px';
    personImg.style.bottom = '0';
    personImg.style.visibility = 'visible';
    personImg.style.transition = 'none';
    }

    function setThumbPosition(heightCm) {
      currentHeight = heightCm;

      const trackHeight = track.offsetHeight;
      const thumbH = thumb.offsetHeight;
      const ratio = (heightCm - min) / (max - min);
      const top = (1 - ratio) * (trackHeight - thumbH);
      thumb.style.top = `${top}px`;

      valueEl.textContent = `${heightCm}cm`;
      const displayEl = blockEl.querySelector('#height-display');

      if (displayEl) {
        const heightText = displayEl.dataset.translation || 'Height';
        displayEl.innerHTML = `${heightCm}cm ${heightText}`;
      }

      updateMatch(heightCm);
      updatePersonHeight(heightCm);

      const lineTop = top + thumbH;
      const lineHeight = trackHeight - lineTop;
      line.style.top = `${lineTop}px`;
      line.style.height = `${lineHeight}px`;
      line.style.width = `${track.offsetWidth}px`;
      line.style.transition = 'none';
    }

    function onDrag(e) {
      if (!dragging) return;
      e.preventDefault();

      const trackRect = track.getBoundingClientRect();
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      let offsetY = clientY - trackRect.top;
      offsetY = Math.max(0, Math.min(offsetY, trackRect.height));

      const ratio = 1 - offsetY / trackRect.height;
      const heightCm = Math.round(min + ratio * (max - min));
      setThumbPosition(heightCm);
    }

    thumb.addEventListener('mousedown', e => {
      e.preventDefault();
      dragging = true;
      document.body.style.userSelect = 'none';
    });
    thumb.addEventListener('touchstart', e => {
      dragging = true;
      document.body.style.userSelect = 'none';
    }, { passive: true });

    document.addEventListener('mouseup', () => {
      dragging = false;
      document.body.style.userSelect = '';
    });
    document.addEventListener('touchend', () => {
      dragging = false;
      document.body.style.userSelect = '';
    });
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('touchmove', onDrag, { passive: false });

    function init() {
      const tryInit = () => {
        const trackHeight = track.offsetHeight;
        const bikeReady = bikeImg && bikeImg.naturalWidth > 0;
        if (trackHeight > 0 && bikeReady) {
          setThumbPosition(midHeight);
        } else {
          requestAnimationFrame(tryInit);
        }
      };

      if (bikeImg && !bikeImg.complete && 'decode' in bikeImg) {
        bikeImg.decode().finally(tryInit);
      } else if (bikeImg && !bikeImg.complete) {
        bikeImg.addEventListener('load', tryInit, { once: true });
      } else {
        tryInit();
      }

      if (bikeImg) {
        const ro = new ResizeObserver(() => setThumbPosition(currentHeight));
        ro.observe(bikeImg);
      }
      window.addEventListener('resize', () => setThumbPosition(currentHeight));
    }

    init();
  });
});
